import Cookies from "js-cookie"

const TokenKey = "hdjn_tjtf_token"

export function getToken() {
  return Cookies.get(TokenKey)
  // 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJVc2VyIjp7IklkIjoiMDAwMDAwMDAtMDAwMC0wMDAwLTAwMDAtMDAwMDAwMDAwMDAwIiwiQWNjb3VudCI6IlN5c3RlbSIsIk5pY2tOYW1lIjoi6LaF57qn566h55CG5ZGYIiwib3BlbmlkIjpudWxsLCJwaG9uZSI6IiJ9LCJSb2xlIjp7IklkIjpudWxsLCJOYW1lIjpudWxsLCJQbGF0Zm9ybU5hbWUiOm51bGwsIlBsYXRmb3JtTG9nb1BhdGgiOm51bGwsIlBsYXRmb3JtVGhlbWVDb2xvcnMiOjB9fQ.613dagIGsLYnN0QJu1dun0dbaEuGbNUOI802g7fyThM'
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getRoleInfo() {
  return Cookies.get("roleInfo")
}

export function getUserInfo() {
  return Cookies.get("userInfo")
}
export function getRoleMoudules() {
  return Cookies.get("rolemoudule")
}
export function getUserMenus() {
  return Cookies.get("usermenus")
}
